import Vue from 'vue';
moment.locale(window.App.lang);
import frlocale from 'element-ui/lib/locale/lang/fr';
import enlocale from 'element-ui/lib/locale/lang/en';
import ElementUI from 'element-ui';
import VueFilters from './filters/vue_filters';
import { Compass2 } from '@sellsy/compass2';
import Translator from 'gettext-translator';
const locale = window.App.locale.split('.')[0];
let keyTranslations = {};
try {
    keyTranslations = require(`../../../../public/ressources/locales/messages.${locale}.json`);
} catch (e) {
    keyTranslations = require(`../../../../public/ressources/locales/messages.fr_FR.json`);
}

Vue.use({
    install(Vue, options) {
        Vue.prototype.$l10n = window.i18n;
        Vue.prototype.$t = new Translator(keyTranslations);
    },
});
Vue.use(Compass2);

var EventBus = (window.EventBus = new Vue());

Vue.prototype.$ajax = window.SellsyJS.WebServiceCaller;
Vue.prototype.$storeHasModule = (path) => window.sellsyapp.$store._modules.root._children[path];

export { ElementUI, frlocale, enlocale };
